// extracted by mini-css-extract-plugin
export default {"FirstHeader":"DefaultTable_FirstHeader__JSATz","CheckboxRow":"DefaultTable_CheckboxRow__O7Hoi"};